import React, { useState } from 'react'
import { ExpandableBarChartProps } from './ExpandableBarChart.types'
import styles from './ExpandableBarChart.module.scss'
import cl from 'classnames'
import { ChartHeader } from 'components/charts'

const ExpandableBarChartComponent = (props: ExpandableBarChartProps) => {
  const {
    className,
    style,
    children,
    chartHeaderProps,
    initialChartVisibility
  } = props

  const [chartVisible, setChartVisibility] = useState<boolean>(Boolean(initialChartVisibility))

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <ChartHeader
        {...chartHeaderProps}
        onExpandClick={() => setChartVisibility(true)}
        onCollapseClick={() => setChartVisibility(false)}
        initialIsExpandedState={initialChartVisibility}
      />

      {chartVisible && (
        <div className={styles.chartContainer}>
          {children}
        </div>
      )}
    </div>
  )
}

const ExpandableBarChart = ExpandableBarChartComponent
export { ExpandableBarChart }
